import { RadioButtonProps } from "./types/radioButtonProps";
import './radioButton.scss';

const RadioButton = (props: RadioButtonProps) => {
    const keyboardNavSelect = (event: any) => { 
        // Enter
        return event.keyCode === 13 && props.onClick && props.onClick(event, props.value); 
    }
    
    return (
        <div tabIndex={props.disabled ? -1 : 0} onKeyDown={keyboardNavSelect} className="radio-item">
            <input className={props.className} checked={props.checked} disabled={props.disabled} id={`${props.name}_${props.inputName}`} style={props.style} type="radio" 
            onClick={(e: any) => {if(props.onClick) props.onClick(e, props.value)}} name={props.inputName} value={props.value} onChange={e => {}}/>
            <label htmlFor={`${props.name}_${props.inputName}`}>
                {props.name}
            </label>
        </div>
    )
}

export default RadioButton;